import { ADIInvoiveDetailsModal, ADIInvoiveDetailsParams, getInvoiceDetails } from "@NA/Services/ADIInvoiceService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<ADIInvoiveDetailsParams & HasOnSuccess & HasOnError, ADIInvoiveDetailsModal>;

export const DispatchBeginLoadInvoiceDetails: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadInvoiceDetails",
        parameter:props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getInvoiceDetails(props.apiParameter);
};

export const CompleteLoadDInvoiceDetails: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteInvoiceDetails",
            invoiceDetailsResult: props.apiResult
        });
    }
};

export const chain = [DispatchBeginLoadInvoiceDetails, PopulateApiParameter, RequestDataFromApi, CompleteLoadDInvoiceDetails];

const adiLoadInvoiceDetails = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        invoiceNumber: "",
        invoiceType:"" // Added paramters is a P21 Change
    },
    "adiLoadInvoiceDetails",
);
export default adiLoadInvoiceDetails;
